import React from 'react';
import styled from 'styled-components';
import cn from 'classnames';
import style from './style';

const Styled = styled.div`
  ${style}
`;

const TermsAndConditions = ({ activeFormsAndWaivers, showModal = false }) => {
  return (
    <Styled showModal={showModal} className={cn('terms-and-conditions')}>
      <div>
        <div data-testid="termsAndConditions">
          <pre className={'terms-and-conditions-value'}>
            {activeFormsAndWaivers[0]?.label ?? activeFormsAndWaivers[0]?.content}
          </pre>
        </div>
      </div>
    </Styled>
  );
};

export default TermsAndConditions;
